// extracted by mini-css-extract-plugin
module.exports = {"timer-counter":"styles_timer-counter__31wB5"};